module.exports = __webpack_public_path__ + "img/84.d0c972ce.jpg";